import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Action icon. Exported from Figma (Bombiix 2026). */
const ActionIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M4.66699 9.33398H12.667C13.9241 9.33398 14.5526 9.33398 14.9431 9.72451C15.3337 10.115 15.3337 10.7436 15.3337 12.0007V12.6673C15.3337 14.5529 15.3337 15.4957 14.7479 16.0815C14.1621 16.6673 13.2193 16.6673 11.3337 16.6673H8.66699C6.78137 16.6673 5.83857 16.6673 5.25278 16.0815C4.66699 15.4957 4.66699 14.5529 4.66699 12.6673V9.33398Z"
      stroke="currentColor"
    />
    <path
      d="M4.66752 9.33376C4.34499 8.13006 4.18373 7.52822 4.32243 7.01058C4.41329 6.67147 4.59182 6.36225 4.84007 6.114C5.21901 5.73507 5.82085 5.5738 7.02454 5.25127L11.6932 4.00031C12.142 3.88005 12.3664 3.81992 12.563 3.80704C13.3702 3.75413 14.1298 4.19268 14.4875 4.91818C14.5747 5.09485 14.6348 5.31926 14.755 5.76808C14.7951 5.91769 14.8152 5.99249 14.8195 6.05801C14.8371 6.32708 14.6909 6.58027 14.4491 6.69953C14.3902 6.72857 14.3154 6.74861 14.1658 6.7887L4.66752 9.33376Z"
      stroke="currentColor"
    />
    <path d="M11.8006 3.96155L11.3754 7.52639" stroke="currentColor" strokeLinecap="round" />
    <path d="M7.61505 5.08264L7.18988 8.64749" stroke="currentColor" strokeLinecap="round" />
  </svg>
);

export default ActionIcon;
